import { render } from "./social-login-main.vue?vue&type=template&id=290d29d8"
import script from "./social-login-main.vue?vue&type=script&lang=js"
export * from "./social-login-main.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__